<section class="con">
  <div class="top-nav">
    <div class="top-nav__eva-logo">
      <img src="../../../assets/logo_eva.png" alt="" srcset="" />
    </div>
    <div class="top-nav__med-logo">
      <img *ngIf="logoUrl" [src]="logoUrl" alt="" srcset="" />
    </div>

    <div class="nav-bar__toggle__icon" id="toggler" (click)="toogleFunction()">
      <span class="material-icons">
        menu
        </span>
    </div>
  </div>

  <div class="toggle" id="tog" >
    <div class="toggle__wrapper">
      <nav id="nav">
        <ul id="tooglerUl" >
          <li class="toogle__wrapper__item" *ngFor="let item of fragments" (click)="toogleUIFunction()">
            <a [routerLink]="['/']" [fragment]="item.url">{{
              item.label
            }}</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</section>
